import { ICurrency } from "../models/User";

class CurrencyStore {
    private _currency: ICurrency;

    constructor(currency: ICurrency) {
        this._currency = currency;
    }

    public get currency_code() {
        return this._currency.currency_code;
    }
}

export default CurrencyStore;
